import { render, staticRenderFns } from "./VView.vue?vue&type=template&id=410c3d8e&scoped=true&"
import script from "./VView.vue?vue&type=script&lang=js&"
export * from "./VView.vue?vue&type=script&lang=js&"
import style0 from "./VView.vue?vue&type=style&index=0&id=410c3d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410c3d8e",
  null
  
)

export default component.exports